import { Link } from "react-router-dom";

export default function Pending() {
  return (
    <div className="form-container" style={{ textAlign: "center" }}>
      <div style={{ fontSize: "60px", marginBottom: "20px" }}>🌱</div>
      <h1>Application Under Review</h1>
      <p style={{ fontSize: "18px", maxWidth: "500px", margin: "0 auto 20px" }}>
        Thank you for applying to SOWS! Your application is currently under review.
        You'll receive an email and be able to access your dashboard as soon as
        you've been accepted into the program.
      </p>
      <p style={{ fontSize: "18px", maxWidth: "500px", margin: "0 auto 30px" }}>
        If you haven't heard back in a while, don't hesitate to reach out to us —
        we'd love to hear from you!
      </p>
      <Link to="/contact" className="pink-btn">Contact Us</Link>
    </div>
  );
}